const getConfig = () => {
    const hostname = window.location.hostname;
  
    if (hostname === 'billing-collection.amaphil.com.ph') {
      return {
        BASE_URL: 'https://billing-collection.amaphil.com.ph/api/v1',
        WEBSOCKET_HOST: 'billing-collection.amaphil.com.ph/socket.io',
      };
    } else if (hostname === 'staging-billing-collection.amaphil.com.ph') {
      return {
        BASE_URL: 'https://staging-billing-collection.amaphil.com.ph/api/v1',
        WEBSOCKET_HOST: 'staging-billing-collection.amaphil.com.ph/socket.io',
      };
    } else {
      // Default configuration (e.g., for local development or fallback to staging)
      return {
        BASE_URL: 'https://staging-billing-collection.amaphil.com.ph/api/v1',
        WEBSOCKET_HOST: 'staging-billing-collection.amaphil.com.ph/socket.io',
      };
    }
  };
  
  const { BASE_URL, WEBSOCKET_HOST } = getConfig();
  
  export { BASE_URL, WEBSOCKET_HOST };